(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('braintreeWrapper', braintreeWrapper);

    function braintreeWrapper() {
        return {
            restrict: 'E',
            controller: braintreeWrapperCtrl,
            controllerAs: 'btWrap',
            scope: {
                options: '=',
                callback: '=',
            },
            bindToController: true,
            templateUrl: 'common/app/components/braintree-wrapper'
        };
    }

    function braintreeWrapperCtrl(lodash) {
        var btWrap = this;
        this.$onInit = function () {
            btWrap.callback = callback;

            btWrap.btInstance = null;

            var btOpts = lodash.extend({
                container: '#dropin-container',
            }, btWrap.options);

            braintree.dropin.create(btOpts, function(createErr, instance) {
                btWrap.btInstance = instance;
            });

            // braintree.dropin.create({
            //     authorization: '{{$token}}',
            //     container: '#dropin-container',
            //     vaultManager: true,
            //     card: {
            //         cardholderName: true
            //     },
            //     paypal: {
            //         flow: 'vault'
            //     }
            // }, function (createErr, instance) {
            //     button.addEventListener('click', function () {
            //         instance.requestPaymentMethod(function (err, payload) {
            //             // Submit payload.nonce to your server
            //             console.log(err, payload);
            //         });
            //     });
            // });
        }


        function callback() {
            if (btWrap) {
                btWrap.btInstance.requestPaymentMethod(function (err, payload) {
                    // Submit payload.nonce to your server
                    console.log(err, payload);
                });
            }
        }
    }
})();